const dict = {
  languageName: 'Türkçe',
  locale: 'tr',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: 'Tema',
  'theme.light': 'Açık',
  'theme.dark': 'Koyu',
  'theme.system': 'Sistem',
  'theme.sakura': 'Sakura',

  // generic
  email: 'E-posta',
  password: 'Şifre',
  ok: 'Tamam',
  cancel: 'İptal',
  retry: 'Yeniden Dene',
  copy: 'Kopyala',
  empty: '(öğe yok)',
  loading: 'Yükleniyor...',
  calculating: 'Hesaplanıyor...',
  error: 'Hata',

  'in_development': 'Bu sayfa geliştirme aşamasındadır.',

  // errors
  'error.not_found': 'bulunamadı',
  'error.name_conflict': 'isim çakışması',
  'error.bad_param': 'geçersiz parametre',
  'error.wrong_auth': 'yanlış kimlik doğrulama',
  'error.unauthorized': 'yetkisiz',
  'error.wrong_credentials': 'yanlış kimlik bilgileri',
  'error.wrong_provider': 'yanlış sağlayıcı',
  'error.insufficient_privileges': 'yetersiz yetki',
  'error.not_empty': 'boş değil',
  'error.limit_exceeded': 'limit aşıldı',
  'error.already_member': 'zaten üye',
  'error.not_finalized': 'tamamlanmadı',
  'error.already_finalized': 'zaten tamamlandı',
  'error.unexpected_patch': 'beklenmedik yama',
  'error.timeout': 'zaman aşımı',
  'error.not_patch': 'yama değil',
  'error.not_supported': 'desteklenmiyor',
  'error.unexpected_error': 'beklenmedik hata',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': 'Kimlik Doğrulama',
  'auth.dialog.please_select': 'Giriş yapmak için lütfen hesap sağlayıcınızı seçin.',
  'auth.dialog.redirecting_to': (provider) => `${provider} sayfasına yönlendiriliyorsunuz...`,
  'auth.dialog.remember_me': 'Beni hatırla',
  'auth.dialog.log_in': 'Giriş yap',
  'auth.dialog.back': 'Geri',
  'auth.dialog.progress_header': 'Kimlik doğrulanıyor...',
  'auth.dialog.error.header': 'Kimlik doğrulama hatası',
  'auth.dialog.error.auth_not_allowed': 'Bu kimlik bilgisinin kimlik doğrulama için kullanılması kullanıcı tarafından yasaklanmıştır. Lütfen başka bir kimlik bilgisi kullanın.',
  'auth.dialog.error.unknown': 'Geçersiz kimlik doğrulama parametreleri. Lütfen tekrar deneyin.',
  'auth.dialog.error.back': 'Geri dön',

  'user.profile': 'Profil',
  'user.logout': 'Çıkış yap',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': 'Sayfa bulunamadı',
  'page_not_found.message': 'Bu sayfa mevcut değil.',
  'page_not_found.message2': 'Aslında bir nevi mevcut, ancak burada hiçbir şey yok. Olasılıklar şunlardır:',
  'page_not_found.items': [
    'Daha önce burada bir şey vardı, ancak şimdi silindi.',
    'Burada hala bir şey var, ancak erişiminiz yok.',
    'Veya birisi bağlantıyı kopyalayıp yapıştırırken dikkatli davranmadı.',
  ],

  'home': 'Ana Sayfa',
  'home.header.hint': 'Bağımsız geliştiriciler için bulut araçları',
  'home.description': 'Kavykhi.Cloud, bağımsız oyunlar için bir geliştirme platformudur. İndirilebilir ve tarayıcı oyunlarını, özel ve genel sürümleri, dalları, ekipleri ve çok daha fazlasını destekliyoruz.',
  'home.auth': 'Giriş yap veya kaydol',
  'home.auth.hint': 'Yeni hesap oluşturun veya mevcut hesaba giriş yapın',

  'projects': 'Projeler',
  'projects.hint': 'Üzerinde çalıştığınız projeler',
  'projects.project': (project) => `Proje: ${project}`,
  'projects.project.hint': 'proje',
  'projects.no_projects': 'Henüz hiç projeniz yok.',
  'projects.new': 'Proje oluştur',
  'projects.new_dialog.header': 'Yeni proje',
  'projects.new_dialog.label': 'Proje adı',
  'projects.new_dialog.ok': 'Proje oluştur',
  'projects.store_page': 'Genel mağaza sayfası',
  'projects.description': 'Açıklama',
  'projects.branches': 'Dallar',
  'projects.versions': 'Sürümler',
  'projects.packages': 'Paketler',
  'projects.management': 'Proje ayarları',
  'projects.management.breadcrumb': 'Ayarlar',
  'projects.management.title': (projectTitle) => `${projectTitle} - ayarlar`,
  'projects.management.hint': 'proje ayarları',
  'projects.management.users': 'Ekip üyeleri',
  'projects.management.users.empty': 'Ekip üyesi yok.',
  'projects.management.users.role.tester': 'Testçi',
  'projects.management.users.role.developer': 'Geliştirici',
  'projects.management.users.role.admin': 'Yönetici',
  'projects.management.users.role.owner': 'Sahip',
  'projects.management.users.role.starred': 'Yıldızlı',
  'projects.management.users.exile': 'Ekipten çıkar',
  'projects.management.users.exile.dialog.header': 'Ekipten çıkar',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>{userTitle} kullanıcısını {projectTitle} projesinden çıkarmak istediğinize emin misiniz?</>,
  'projects.management.users.exile.dialog.ok': 'Ekipten çıkar',
  'projects.management.invites.one_time_invite': 'Tek kullanımlık davet bağlantısı',
  'projects.management.invites.one_time_invite.header': 'Tek kullanımlık davet bağlantısı',
  'projects.management.invites.one_time_invite.message': 'Tek kullanımlık davet bağlantısı:',
  'projects.management.invites.one_time_invite.note': '24 saat geçerlidir, bir kez kullanılabilir.',
  'projects.management.invites.new_dialog.header': 'Davet bağlantısı',
  'projects.management.invites.new_dialog.expires': 'Geçerlilik süresi:',
  'projects.management.invites.new_dialog.expires.indefinite': '(süre sınırı yok)',
  'projects.management.invites.new_dialog.approval.label': 'Kullanıcı projeye katıldığında:',
  'projects.management.invites.new_dialog.approval.not_approved': 'yönetici onayından sonra',
  'projects.management.invites.new_dialog.approval.approved': 'hemen',
  'projects.management.invites.new_dialog.seats': 'Katılım sınırı:',
  'projects.management.invites.new_dialog.seats.no_limit': '(sınır yok)',
  'projects.management.invites.new_dialog.ok': 'Davet bağlantısı oluştur',
  'projects.management.deploy_sites': 'Dağıtım siteleri',
  'projects.management.deploy_sites.empty': 'Hiç dağıtım sitesi eklenmedi.',
  'projects.management.deploy_sites.add': 'Dağıtım sitesi ekle',
  'projects.management.deploy_sites.delete': 'Sil',
  'projects.management.deploy_sites.delete_dialog.header': 'Dağıtım sitesini sil',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>{provider} dağıtım sitesini ({site}) silmek istediğinize emin misiniz?</>,
  'projects.management.deploy_sites.delete_dialog.ok': 'Dağıtım sitesini sil',
  'projects.management.public_access': 'Genel erişim',
  'projects.management.public_access.enable': 'Genel erişimi etkinleştir',
  'projects.management.public_access.enabled': <>Genel erişim: <strong>izin verildi</strong></>,
  'projects.management.public_access.enabled.note': 'Projenin adı, açıklaması ve genel olarak işaretlenmiş tüm dallar herkese açıktır.',
  'projects.management.public_access.enable_dialog.header': 'Genel erişimi etkinleştir',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>{projectTitle} projesine genel erişime izin vermek istediğinize emin misiniz?<br /><br />Bu, proje hakkındaki temel bilgileri kimlik doğrulaması olmadan erişilebilir hale getirecektir. Genel olmasını istediğiniz her dal için genel erişimi ayrı ayrı etkinleştirmeniz gerekecektir.</>,
  'projects.management.public_access.enable_dialog.ok': 'Genel erişimi etkinleştir',
  'projects.management.public_access.disable': 'Genel erişimi devre dışı bırak',
  'projects.management.public_access.disabled': <>Genel erişim: <strong>izin verilmedi</strong></>,
  'projects.management.public_access.disabled.note': 'Proje özeldir. Sadece proje ekibinin üyeleri erişebilir.',
  'projects.management.public_access.disable_dialog.header': 'Genel erişimi devre dışı bırak',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>{projectTitle} projesine olan tüm genel erişimi devre dışı bırakmak istediğinize emin misiniz?</>,
  'projects.management.public_access.disable_dialog.ok': 'Genel erişimi devre dışı bırak',
  'projects.management.public_access.branches': 'Genel dallar',
  'projects.management.manage': 'Projeyi yönet',
  'projects.rename': 'Projeyi yeniden adlandır',
  'projects.rename_dialog.header': 'Projeyi yeniden adlandır',
  'projects.rename_dialog.label': 'Proje adı:',
  'projects.rename_dialog.ok': 'Projeyi yeniden adlandır',
  'projects.edit_description': 'Proje açıklamasını düzenle',
  'projects.edit_description_dialog.header': 'Proje açıklamasını düzenle',
  'projects.edit_description_dialog.label': 'Proje açıklaması:',
  'projects.edit_description_dialog.ok': 'Açıklamayı düzenle',
  'projects.leave': 'Projeden ayrıl',
  'projects.leave_dialog.header': 'Projeden ayrıl',
  'projects.leave_dialog.message': (projectTitle) => <>{projectTitle} projesinden ayrılmak istediğinize emin misiniz?</>,
  'projects.leave_dialog.ok': 'Projeden ayrıl',
  'projects.delete': 'Projeyi sil',
  'projects.delete_dialog.header': 'Projeyi sil',
  'projects.delete_dialog.message': (projectTitle) => <>{projectTitle} projesini silmek istediğinize emin misiniz?</>,
  'projects.delete_dialog.ok': 'Projeyi sil',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': 'dal',
  'branches.no_branches': 'Projenin henüz hiç dalı yok',
  'branches.new': 'Dal oluştur',
  'branches.new_dialog.header': 'Yeni dal',
  'branches.new_dialog.label': 'Dal adı',
  'branches.new_dialog.ok': 'Dal oluştur',
  'branches.current_version': (version) => <>Mevcut sürüm: {version}</>,
  'branches.current_version.packages': 'Mevcut sürüm paketleri',
  'branches.no_current_version': 'Mevcut sürüm yok',
  'branches.publish_version.new': 'Yeni sürüm yayınla',
  'branches.publish_version.existing': 'Mevcut sürümü yeniden yayınla',
  'branches.version_history': 'Sürüm geçmişi',
  'branches.version_history.empty': 'Dalın sürüm geçmişi boş.',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>Mevcut dal sürümü {quotaTime != null ? <>{quotaTime} boyunca</> : <>süresiz olarak</>} saklanır. Önceki sürümler en fazla {quotaNonCurrentTime} saklanır. Dal başına toplamda en fazla {plural(quotaCount, <>{quotaCountText} sürüm</>, <>{quotaCountText} sürüm</>)} saklanır.</>,
  'branches.manage': 'Dalı yönet',
  'branches.rename': 'Dalı yeniden adlandır',
  'branches.rename_dialog.header': 'Dalı yeniden adlandır',
  'branches.rename_dialog.label': 'Dal adı:',
  'branches.rename_dialog.ok': 'Dalı yeniden adlandır',
  'branches.delete': 'Dalı sil',
  'branches.delete_dialog.header': 'Dalı sil',
  'branches.delete_dialog.message': (branchTitle) => <>{branchTitle} dalını silmek istediğinize emin misiniz?</>,
  'branches.delete_dialog.ok': 'Dalı sil',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': 'sürüm',
  'versions.current': 'Mevcut',
  'versions.previous': 'Önceki',
  'versions.description': 'Açıklama',
  'versions.deploy_to_site.header': 'Sitede yayınla',
  'versions.deploy_to_site': 'Sitede yayınla',
  'versions.packages': 'Paketler',
  'versions.branches': 'Dallarda',
  'versions.branches.publish': 'Dala gönder',
  'versions.branches.empty': 'Bu sürüm hiçbir dalda yayınlanmadı.',
  'versions.new_dialog.header': 'Yeni sürüm',
  'versions.new_dialog.label_title': 'Sürüm:',
  'versions.new_dialog.label_branch': 'Dal:',
  'versions.new_dialog.packages.header': 'Paketler',
  'versions.new_dialog.packages.empty': 'Hiç paket eklenmedi.',
  'versions.new_dialog.packages.add': 'Paket ekle',
  'versions.new_dialog.packages.add_existing': 'Önceden yüklenmiş paketi ekle',
  'versions.new_dialog.packages.replace': 'Paketi değiştir',
  'versions.new_dialog.packages.edit': 'Paketi düzenle',
  'versions.new_dialog.ok': 'Sürüm oluştur',
  'versions.manage': 'Sürümü yönet',
  'versions.rename': 'Sürümü yeniden adlandır',
  'versions.rename_dialog.header': 'Sürümü yeniden adlandır',
  'versions.rename_dialog.label': 'Sürüm adı:',
  'versions.rename_dialog.ok': 'Sürümü yeniden adlandır',
  'versions.edit_description': 'Sürüm açıklamasını düzenle',
  'versions.edit_description_dialog.header': 'Sürüm açıklamasını düzenle',
  'versions.edit_description_dialog.label': 'Sürüm açıklaması:',
  'versions.edit_description_dialog.ok': 'Açıklamayı düzenle',
  'versions.delete': 'Sürümü sil',
  'versions.delete_dialog.header': 'Sürümü sil',
  'versions.delete_dialog.message': (versionTitle) => <>Sürüm {versionTitle} silmek istediğinize emin misiniz?</>,
  'versions.delete_dialog.ok': 'Sürümü sil',

  'versions.publish_dialog.header': 'Sürümü bir dala gönder',
  'versions.publish_dialog.message': (versionTitle) => <>Sürüm {versionTitle} göndermek istediğiniz dalı seçin.</>,
  'versions.publish_dialog.no_branches': 'Projede hiç dal yok.',
  'versions.publish_dialog.ok': 'Sürümü gönder',

  'versions.publish_existing_dialog.header': 'Sürümü yeniden gönder',
  'versions.publish_existing_dialog.message': 'Son sürümler:',
  'versions.publish_existing_dialog.no_versions': 'Projede hiç sürüm yok.',
  'versions.publish_existing_dialog.ok': 'Sürümü gönder',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': 'Paket',
  'packages.download_zip': 'ZIP olarak indir',
  'packages.download_torrent': 'Torrent indir',
  'packages.total_size': (size) => <>Toplam boyut: {size}</>,
  'packages.manage': 'Paketi yönet',
  'packages.rename': 'Paketi yeniden adlandır',
  'packages.rename_dialog.header': 'Paketi yeniden adlandır',
  'packages.rename_dialog.label': 'Paket adı:',
  'packages.rename_dialog.ok': 'Paketi yeniden adlandır',
  'packages.edit_tags': 'Paket etiketlerini düzenle',
  'packages.edit_tags_dialog.header': 'Paket etiketlerini düzenle',
  'packages.edit_tags_dialog.message': (packageTitle) => <>{packageTitle} paketinin etiketlerini belirtin:</>,
  'packages.edit_tags_dialog.ok': 'Paket etiketlerini ayarla',
  'packages.entrypoint': (entrypoint) => <>Başlangıç dosyası: {entrypoint}</>,
  'packages.entrypoint.empty': 'Başlangıç dosyası ayarlanmadı.',
  'packages.delete': 'Paketi sil',
  'packages.delete_dialog.header': 'Paketi sil',
  'packages.delete_dialog.message': (packageTitle) => <>{packageTitle} paketini silmek istediğinize emin misiniz? Paket, eklendiği tüm sürümlerden silinecektir.</>,
  'packages.delete_dialog.ok': 'Paketi sil',

  'packages.new_dialog.header': 'Yeni paket',
  'packages.new_dialog.label_title': 'Başlık:',
  'packages.new_dialog.title_placeholder': '(etiketlerden)',
  'packages.new_dialog.tags.header': 'Etiketler',
  'packages.new_dialog.files.header': 'Dosyalar',
  'packages.new_dialog.total_size': (size, maximum) => <>Toplam boyut: {size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(maksimum {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>Yeni veri boyutu: {size}</>,
  'packages.new_dialog.checks.empty': 'Hiç dosya eklenmedi.',
  'packages.new_dialog.checks.entrypoint.empty': 'Başlangıç dosyası ayarlanmadı.',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>Başlangıç dosyası {entrypoint} mevcut değil; eklemeyi unutmuş olabilir misiniz? Lütfen mevcut bir başlangıç dosyası belirtin veya hiç başlangıç dosyası ayarlamayın.</>,
  'packages.new_dialog.checks.entrypoint.missing.action': 'Başlangıç dosyasını kaldır',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>Başlangıç dosyası {fileExt} uzantısına sahip: {tag} etiketi öneriliyor.</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>{tag} etiketini ekle</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>Başlangıç dosyası {fileExt} uzantısına sahip: paketi tarayıcıda oynatılabilir kılmak için {tag} etiketini ekleyin.</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>Başlangıç dosyası {fileExt} uzantısına sahip: bu bir hata mı? Genellikle bu tür dosyalar başlatılamaz.</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>Başlangıç dosyası {fileExt} uzantısına sahip: dosyaları bir arşiv dosyasına paketlemek yerine doğrudan eklemeniz önerilir.</>,
  'packages.new_dialog.checks.entrypoint.executable': 'Başlangıç dosyası çalıştırılabilir olarak işaretlenmemiş',
  'packages.new_dialog.checks.entrypoint.executable.action': 'Çalıştırılabilir olarak işaretle',
  'packages.new_dialog.checks.single_root_dir': 'Dosyaları tek bir klasör içine koymak yerine doğrudan kök dizine yerleştirmeniz önerilir.',
  'packages.new_dialog.checks.single_root_dir.action': 'Klasörü içeriğiyle değiştir',

  'packages.add_existing_dialog.header': 'Paket ekle',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `${plural(packagesCount, `${packagesCount} paket`, `${packagesCount} paket`)} ekle` : 'Hiç paket seçilmedi',
  'packages.add_existing_dialog.message': 'Son yüklenen paketler:',
  'packages.add_existing_dialog.no_packages': 'Yakın zamanda yüklenmiş paket yok.',

  'packages.launch': 'Başlat',

  'packages.install': 'Yükle',
  'packages.install_dialog.header': 'Yükle',
  'packages.install_dialog.workdir.label': 'Çalışma dizini:',
  'packages.install_dialog.workdir.value.new': '(yeni oluştur)',
  'packages.install_dialog.workspace.label': 'Şunun altında klasör oluştur:',
  'packages.install_dialog.workspace.placeholder': '(kök klasörü seçin)',
  'packages.install_dialog.ok': 'Yükle',

  'packages.update': 'Güncelle',

  'packages.upload.status.existing': 'Önceki sürümden',
  'packages.upload.status.queued': 'Sırada',
  'packages.upload.status.packing': 'Paketleniyor...',
  'packages.upload.status.creating': 'Oluşturuluyor...',
  'packages.upload.status.create_retrying': 'Oluşturma başarısız oldu, bekleniyor ve yeniden deneniyor',
  'packages.upload.status.splitting': 'Bölünüyor...',
  'packages.upload.status.uploading': 'Yükleniyor...',
  'packages.upload.status.finalizing': 'Tamamlanıyor...',
  'packages.upload.status.finalize_retrying': 'Tamamlama başarısız oldu, bekleniyor ve yeniden deneniyor',
  'packages.upload.status.resolving': 'Yama çözümleniyor...',
  'packages.upload.status.resolve_retrying': 'Yama çözümleme başarısız oldu, bekleniyor ve yeniden deneniyor...',
  'packages.upload.status.done': 'Başarıyla yüklendi',
  'packages.upload.status.errored': 'Hata',

  'packages.upload.part.status.queued': 'Sırada',
  'packages.upload.part.status.hashing': 'Karma oluşturuluyor',
  'packages.upload.part.status.upload_queued': 'Yükleme sıraya alındı',
  'packages.upload.part.status.uploading': 'Yükleniyor',
  'packages.upload.part.status.upload_retrying': 'Hata, yükleme yeniden deneniyor',
  'packages.upload.part.status.upload_finalizing': 'Yükleme tamamlanıyor',
  'packages.upload.part.status.upload_errored': 'Hata',
  'packages.upload.part.status.done': 'Yüklendi',

  'packages.play': 'Tarayıcıda oyna',
  'packages.play.reset': 'Sıfırla',
  'packages.play.fullscreen': 'Tam ekran',

  'deploy_sites.add_dialog.header': 'Dağıtım sitesi ekle',
  'deploy_sites.add_dialog.message': (projectTitle) => <>{projectTitle} projesi için dağıtım sitesi olarak kaydetmek üzere dağıtım kimlik bilgisini seçin ve site URL\'sini girin.</>,
  'deploy_sites.add_dialog.label_credential': 'Dağıtım kimlik bilgisi:',
  'deploy_sites.add_dialog.select_credential': 'Kimlik bilgisi seç',
  'deploy_sites.add_dialog.select_credential.new': 'Yeni kimlik bilgisi ekle...',
  'deploy_sites.add_dialog.label_select_site': 'Site seç:',
  'deploy_sites.add_dialog.select_credential_first': '(önce kimlik bilgisi seçin)',
  'deploy_sites.add_dialog.select_site': '(site seçin)',
  'deploy_sites.add_dialog.label_enter_site': 'Veya site URL\'si girin:',
  'deploy_sites.add_dialog.ok': 'Site ekle',

  'deploy_to_site_dialog.header': 'Sitede yayınla',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>{projectTitle} projesinin {versionTitle} sürümünü yayınlamak için site seçin.</>,
  'deploy_to_site_dialog.label_site': 'Sitede yayınla:',
  'deploy_to_site_dialog.select_site': 'Site seç',
  'deploy_to_site_dialog.select_site.new': 'Yeni dağıtım sitesi ekle...',
  'deploy_to_site_dialog.packages.message.itch': <>Paketler, <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a> kullanılarak itch.io\'da yayınlanacaktır. Kanal adları paket etiketlerinden türetilir.</>,
  'deploy_to_site_dialog.deploy': 'Yayınla',
  'deploy_to_site_dialog.close': 'Kapat',
  'deploy_to_site_dialog.error.no_packages': 'Yayınlanacak paket yok.',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>Birden fazla paket tek bir kanalda yayınlanamaz. Şu anda {channel} kanalında yayınlanmak üzere {plural(packagesCount, <>{packagesCountText} paket</>, <>{packagesCountText} paket</>)} ayarlanmış durumda.</>,
  'deploy_to_site_dialog.job.queued': 'Sırada',
  'deploy_to_site_dialog.job.downloading': 'İndiriliyor...',
  'deploy_to_site_dialog.job.unpacking': 'Paket açılıyor...',
  'deploy_to_site_dialog.job.uploading': 'Yayınlanıyor...',
  'deploy_to_site_dialog.job.succeeded': 'Başarılı',
  'deploy_to_site_dialog.job.errored': 'Hata',

  'store': 'Mağaza',
  'store.hint': 'Genel projeler',
  'store.project.hint': 'Mağaza proje sayfası',
  'store.project.owner': 'Geliştirici',
  'store.project.description': 'Açıklama',
  'store.project.star': 'Yıldızla',
  'store.project.starred': 'Yıldızlı',
  'store.project.content': 'İçerik',
  'store.project.content.warning': 'İçerik üçüncü taraf bir geliştirici tarafından sağlanmıştır.',
  'store.project.branch_version': (branchTitle, versionTitle) => <>{branchTitle} dalı: sürüm {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>Yayınlanma: {branchVersionPublished}</>,

  'me': 'Profil',
  'me.hint': 'Profil ayarları ve bağlı kimlik bilgileri',
  'me.rename': 'Profili yeniden adlandır',
  'me.rename_dialog.header': 'Profili yeniden adlandır',
  'me.rename_dialog.label_title': 'Ad:',
  'me.rename_dialog.ok': 'Profili yeniden adlandır',
  'me.credentials': 'Kimlik Bilgileri',
  'me.credentials.hint.auth_allowed': 'Bu kimlik bilgilerinden herhangi biri bu hesaba giriş yapmak için kullanılabilir.',
  'me.credentials.hint.auth_disallowed': 'Bu kimlik bilgileri hesabınıza bağlıdır ancak giriş yapmak için kullanılamaz.',
  'me.credentials.empty': 'Kimlik bilgisi yok.',
  'me.credentials.empty.auth_allowed.warning': 'Hesabınızdan kilitlenebilirsiniz! Giriş yapmak için hiçbir kimlik bilgisi bağlamadınız. Lütfen en kısa sürede giriş yapabileceğiniz bir kimlik bilgisi bağlayın.',
  'me.credentials.profile_picture.alt': (provider) => `${dict[`auth.provider.${provider}`]} profil resmi`,
  'me.credentials.created': (created) => <>eklendi {created}</>,
  'me.credentials.last_used': (lastUsed) => <>son kullanım {lastUsed}</>,
  'me.credential.unlink': 'Bağlantıyı Kes',
  'me.credential.allow_auth': 'Girişe izin ver',
  'me.credential.disallow_auth': 'Girişi engelle',
  'me.credential.display_publicly': 'Herkese açık göster',
  'me.credential.dont_display_publicly': 'Herkese açık gösterme',
  'me.credential.link': 'Kimlik bilgisi bağla',
  'me.credential.link_dialog.header': 'Kimlik bilgisi bağla',
  'me.credential.link_dialog.message': 'Lütfen bağlamak istediğiniz hesap sağlayıcısını seçin.',
  'me.credential.unlink_dialog.header': 'Kimlik bilgisi bağlantısını kes',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>{credentialProvider} hesabı {credentialTitle} ile Kavykhi.Cloud hesabınız arasındaki bağlantıyı kesmek istediğinize emin misiniz?</>,
  'me.credential.unlink_dialog.ok': 'Bağlantıyı kes',
  'me.sessions': 'Oturumlar',
  'me.sessions.hint': 'Bu, mevcut tarayıcınız dahil aktif oturumlarınızın listesidir.',
  'me.sessions.started': (started) => <>başlatıldı <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>aktif <span class="value">{lastAuth}</span></>,
  'me.sessions.current': 'Mevcut oturum',
  'me.sessions.empty': 'Oturum yok.',
  'me.sessions.delete': 'Sonlandır',
  'me.sessions.delete_dialog.header': 'Oturumu sonlandır',
  'me.sessions.delete_dialog.message': 'Bu oturumu sonlandırmak istediğinize emin misiniz?',
  'me.sessions.delete_dialog.ok': 'Oturumu sonlandır',
  'me.api_tokens': 'API anahtarları',
  'me.api_tokens.hint': 'Otomasyonda kullanmak üzere buradan API anahtarları oluşturulabilir.',
  'me.api_tokens.started': (started) => <>oluşturuldu <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>son kullanma <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': 'süre sınırı yok',
  'me.api_tokens.empty': 'API anahtarı yok.',
  'me.api_tokens.create': 'API anahtarı oluştur',
  'me.api_tokens.create_dialog.header': 'API anahtarı oluştur',
  'me.api_tokens.create_dialog.message': 'Oluşturulan API anahtarı:',
  'me.api_tokens.create_dialog.note': 'Anahtar bir daha gösterilmeyecektir, lütfen güvenli bir yere kaydedin.',
  'me.api_tokens.delete': 'Sil',
  'me.api_tokens.delete_dialog.header': 'API anahtarını sil',
  'me.api_tokens.delete_dialog.message': 'Bu anahtarı silmek istediğinize emin misiniz?',
  'me.api_tokens.delete_dialog.ok': 'API anahtarını sil',
  'me.deploy_credentials': 'Dağıtım kimlik bilgileri',
  'me.deploy_credentials.hint': 'Yayınlama platformlarına dağıtım yapmak için kimlik bilgileri buradan eklenebilir.',
  'me.deploy_credentials.empty': 'Hiç dağıtım kimlik bilgisi eklenmedi.',
  'me.deploy_credential.add': 'Dağıtım kimlik bilgisi ekle',
  'me.deploy_credential.add_dialog.header': 'Dağıtım kimlik bilgisi ekle',
  'me.deploy_credential.add_dialog.label_site': 'Site:',
  'me.deploy_credential.add_dialog.label_title': 'Not:',
  'me.deploy_credential.add_dialog.label_key': 'Anahtar:',
  'me.deploy_credential.add_dialog.default_title': (date) => `Anahtar ${date}`,
  'me.deploy_credential.add_dialog.ok': 'Dağıtım kimlik bilgisi ekle',
  'me.deploy_credential.add_dialog.hint.itch': <>itch.io API anahtarını oluşturmak için itch.io\'daki <a href="https://itch.io/user/settings/api-keys" target="_blank">profil ayarlarınıza</a> gidin. Kaynağı "web" veya "wharf" olan mevcut bir API anahtarını kullanabilirsiniz. Kaynağı "Kavykhi.Cloud" olan API anahtarları çalışmayacaktır.</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>Şu anda {credentialProvider} kimlik bilgilerini eklemeyi desteklemiyoruz.</>,
  'me.deploy_credential.delete': 'Sil',
  'me.deploy_credential.delete_dialog.header': 'Dağıtım kimlik bilgisini sil',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>{credentialProvider} için {credentialTitle} kimlik bilgisini silmek istediğinize emin misiniz? Bu kimlik bilgisiyle yapılandırılmış tüm dağıtım siteleri de projeden kaldırılacaktır.</>,
  'me.deploy_credential.delete_dialog.ok': 'Kimlik bilgisini sil',
  'me.public_profile': 'Genel profil',
  'me.public_profile.public_credentials': 'Genel kimlik bilgileri',
  'me.public_profile.public_credentials.hint': 'Herkese açık olarak gösterilecek kimlik bilgilerini seçin.',
  'me.manage': 'Hesabı yönet',
  'me.delete': 'Hesabı sil',
  'me.delete.dialog.header': 'Hesabı sil',
  'me.delete.dialog.message': (userTitle) => <>Kavykhi.Cloud hesabınızı ({userTitle}) geri alınamaz şekilde silmek istediğinize emin misiniz?</>,
  'me.delete.dialog.ok': 'Hesabı sil',

  'invite': 'Davet',
  'invite.hint': 'Proje daveti',
  'invite.message.already_member': (projectTitle) => <>Zaten {projectTitle} projesinin bir üyesisiniz.</>,
  'invite.message.join': (projectTitle) => <>{projectTitle} projesine davet edildiniz.</>,
  'invite.join': 'Projeye katıl',

  'local': 'Yerel içerik',
  'local.hint': 'Yerel olarak yüklenmiş içerik',
  'local.workdirs': 'Yüklü paketler',
  'local.workdirs.empty': 'Yüklü paket yok.',
  'local.workdir.action.launch': 'Başlat',
  'local.workdir.action.repair': 'Onar',
  'local.workdir.action.delete': 'Kaldır',
  'local.workdir.delete_dialog.header': 'Paketi kaldır',
  'local.workdir.delete_dialog.message': (packageTitle) => <>{packageTitle} paketini cihazınızdan kaldırmak istediğinize emin misiniz?</>,
  'local.workdir.delete_dialog.ok': 'Kaldır',
  'local.workspaces': 'Kök klasörler',
  'local.app_not_detected.message': 'Kavykhi.Cloud yerel uygulaması tespit edilemedi. Lütfen aşağıdaki bağlantılardan birini kullanarak indirip yükleyin. Zaten yüklediyseniz, çalıştığından emin olun.',

  'local_app.detected': 'Yerel içerik',

  'error_dialog.header': 'Hata',
  'error_dialog.messageFunc': (e) => `Hata: ${dict[`error.${e}`] ?? e}.`,

  'upload_box.choose_files': 'Dosya seç',
  'upload_box.choose_directories': 'Klasör seç',
  'upload_box.add.progress_dialog.header': 'Dosyalar ekleniyor',
  'upload_box.add.progress_dialog.message': 'Dosyalar işleniyor...',
  'upload_box.delete': (itemsCount) => `${plural(itemsCount, `${itemsCount} öğeyi`, `${itemsCount} öğeyi`)} sil`,
  'upload_box.start_upload': 'Yüklemeyi başlat',
  'upload_box.drop_area.message': 'Dosya ve klasörleri buraya sürükleyin',
  'upload_box.drop_area.box_dropping_message': 'Kök dizine yerleştirmek için buraya bırakın',
  'upload_box.entry.explode_folder': 'Klasörü içeriğiyle değiştir',
  'upload_box.entry.set_entrypoint': 'Başlangıç dosyası olarak ayarla',
  'upload_box.entry.mark_executable': 'Çalıştırılabilir olarak işaretle',
  'upload_box.entry.unmark_executable': 'Çalıştırılabilir işaretini kaldır',
  'upload_box.entry.remove': 'Kaldır',

  'package.tags.empty': '(etiket yok)',
  'package.tag.os': 'İşletim Sistemi',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': 'Mimari',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': 'Bit Genişliği',
  'package.tag.bits:64': '64-bit',
  'package.tag.bits:32': '32-bit',
  'package.tag.packaging': 'Paketleme',
  'package.tag.packaging:installer': 'Yükleyici',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': 'Bileşen',
  'package.tag.component:client': 'İstemci',
  'package.tag.component:server': 'Sunucu',
  'package.tag.runtime': 'Çalışma Ortamı',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Linux dağıtımı',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': 'Belgeler',
  'docs.page_no_language': 'Bu dilde mevcut değil',
  'docs.page_no_language.message': 'Bu belgenin diğer sürümleri mevcuttur:',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': 'İçeriği bildir',
  'report_content.dialog.header': 'İçeriği bildir',
  'report_content.dialog.link': 'Bildirimi e-posta ile gönder',
  'report_content.dialog.message': (email, link) => <>Bildiriminizi göndermek için lütfen bağlantıya tıklayın:<br /><br />{link}<br /><br />Veya bize manuel olarak şu adresten e-posta gönderin: {email}</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
